import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./components/App";
import Dashboard from "./components/Dashboard/DashboardContainer";
import Mobile from "./components/Mobile/MobileContainer";
import Details from "./components/Details/Details";
import store from "./redux/store/index";
import { urlPath } from "./components/Settings";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import { setConfiguration } from './redux/actions/index';

var urlParams = new URLSearchParams(window.location.search);
const hasBooking = Boolean(urlParams.get("booking"));
const adminMode = Boolean(urlParams.get("admin"));
const bigBucket = Boolean(urlParams.get("bigbucket"));
if (bigBucket) document.body.classList.add("bigBucket");

window.store = store;
//console.log(store.getState());

store.subscribe(() => console.log(store.getState()));
let configData = null;
fetch(urlPath + "/api/noauth/loadconfig", { credentials: 'include' })
    .then((response) => response.json())
    .then((data) => {
        configData = data;
        store.dispatch(setConfiguration(configData));
        renderData();
    })
    .catch((e) => {
        //console.error("Cannot load config", e);
        renderData();
    });
const renderData = () => {
    if (hasBooking) {
        ReactDOM.render(
            <Provider store={store}>
                <Details />
            </Provider>,
            document.getElementById("root")
        );
        return;
    }
    if (
        window.screen.width < 769 &&
        configData &&
        configData["web.campaign.mobile"]
    ) {
        ReactDOM.render(
            <Provider store={store}>
                <Mobile config={configData} />
            </Provider>,
            document.getElementById("root")
        );
        return;
    }
    ReactDOM.render(
        !adminMode ? (
            <Provider store={store}>
                <App config={configData} />
            </Provider>
        ) : (
                <Dashboard />
            ),
        document.getElementById("root")
    );
};
unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js